enum SkuType {
  HKTVmall,
  LittleMall,
  QCS,
}

export default SkuType;
